import React from "react";
import SurveyForm from "../SurveyForm";

function Index({ config }) {
  const items = [
    {
      id: 1,
      name: "Select a survey type",
      options: [
        {
          id: 1,
          label: "Cross Lease CSD without Survey Information - Base Fee",
          price: config.useNewFees ? 313.0 : 230.0,
        },
        {
          id: 2,
          label: "Cross Lease CSD with Survey Information - Base Fee",
          price: 850.0,
        },
      ],
      maxQuantity: 100,
      fixedQuantity: (item) => {
        return null;
      },
      isEnabled: (item) => {
        return true;
      },
    },
    {
      id: 2,
      name: "Non Primary Parcels (excluding Cross-Lease Building and Covenant - Flat/Crosslease)",
      price: config.useNewFees ? 80.0 : 60.0,
      maxQuantity: 500,
      fixedQuantity: (item) => {
        return null;
      },
      isEnabled: (item) => {
        return true;
      },
    },
    {
      id: 3,
      name: "Deposit fee",
      price: config.useNewFees ? 182.0 : 150.0,
      maxQuantity: 100,
      fixedQuantity: (item) => {
        if (!item.selectedOption) return 0;

        return 1;
      },
      isEnabled: (item) => {
        return false;
      },
    },
  ];

  const model = {
    items: items,
    depositFeesId: 3,
    getDepositFeeQuantity: (option, planType) => {
      if (!option) return 0;

      return 1;
    },
  };

  return <SurveyForm title="Cross Lease CSD Fee Calculator" data={model} />;
}

export default Index;
